import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconRedStar = ({
  title = "Red star",
  viewBoxWidth = 24,
  viewBoxHeight = 22,
  ...otherProps
}: SvgIconProps) => (
  <Svg {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <path
      d="M12 18l-7 3.7L6.2 14 .6 8.3 8.5 7 12 0l3.5 7.1 8 1.2-5.8 5.6 1.4 7.8z"
      fill="##B11100"
      fillRule="evenodd"
    />
  </Svg>
)

export default IconRedStar
